<template>
<div>
     <div class="item " :style="{'animation-name':(index==KnowIndex?'upMove':'downMove')}" :class="[KnowIndex==index?'selectMe':'']" @mouseover="tapMouseOverK(index)" @mouseleave="tapMouseLeaveK(index)">        
        <div class="bgs bg-pdf" v-if="item.attr2 =='1'">
            <span class="icon-a" :style="{'animation-name':(index==KnowIndex?'inmove':'downmove')}">
                <img src="../assets/images/home/pdf.png" />
            </span>
        </div>
         
        <div class="bgs bg-word" v-else-if="item.attr2 =='2'">
            <span class="icon-a" :style="{'animation-name':(index==KnowIndex?'inmove':'downmove')}">
                <img src="../assets/images/home/word.png" />
            </span>
        </div>
        
         <div class="bgs bg-excel" v-else-if="item.attr2 =='3'">
            <span class="icon-a" :style="{'animation-name':(index==KnowIndex?'inmove':'downmove')}">
                <img src="../assets/images/home/excel.png" />
            </span>
        </div>

        <div class="bgs bg-ppt" v-else-if="item.attr2 =='4'">
            <span class="icon-a" :style="{'animation-name':(index==KnowIndex?'inmove':'downmove')}">
                <img src="../assets/images/home/ppt.png" />
            </span>
        </div>

         <div class="bgs bg-pic" v-else-if="item.attr2 =='5'">
            <span class="icon-a" :style="{'animation-name':(index==KnowIndex?'inmove':'downmove')}">
                <img src="../assets/images/home/pic.png" />
            </span>
        </div>
        <div class="bgs bg-ppt" v-else-if="item.attr2 =='6'">
            <span class="icon-a" :style="{'animation-name':(index==KnowIndex?'inmove':'downmove')}">
                <img src="../assets/images/home/shipin.png" />
            </span>
        </div>

         <div class="bgs bg-pic" v-else-if="item.attr2 =='7'">
            <span class="icon-a" :style="{'animation-name':(index==KnowIndex?'inmove':'downmove')}">
                <img src="../assets/images/home/yipin.png" />
            </span>
        </div>
         <div class="bgs bg-txt" v-else-if="item.attr2 =='8'">
            <span class="icon-a" :style="{'animation-name':(index==KnowIndex?'inmove':'downmove')}">
                <img src="../assets/images/home/txt.png" />
            </span>
        </div> 
        
        <div class="p24">
          <div class="name">{{item.title}}</div>
          <div class="f14 c9" style="height:58px">文件大小：{{item.attr1}}KB</div>
          <!-- <div class="f14 c9">{{item.attr2}}</div> -->
        </div>                
        <div class="bot">
          <div class="date">查看时间：{{$conFun.parseData(item.attr3)}}</div>
        </div>
    </div>  
 
</div>
</template>
<script>
export default {
     props:{
        index:'',
        item:''
      },
  data() {     
    return {       
        KnowIndex:'-1'      
        //fiFiletype" : 文件类型 1 pdf 2 word 3 excel 4 ppt 5 图片 6 视频 7 音频 8 txt
    }
  },
  methods: {    
    tapMouseOverK(index,type){
       this.KnowIndex = index
    },
    tapMouseLeaveK(index,type){
       this.KnowIndex = '-1'
    }
  }
}
</script>
<style>
.plist .item .bg-pdf{
  background:#E55328
}
.plist .item .bg-word{
  background:#5896E7
}
.plist .item .bg-excel{
  background:#24B291
}
.plist .item .bg-ppt{
  background:#F48549
}
.plist .item .bg-pic{
  background:#5896E7
}
.plist .item .bg-txt{
  background:#FFFFFF
}
</style>



// WEBPACK FOOTER //
// src/components/KnowItem.vue